var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "arrow-down_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4a1 1 0 011 1v14a1 1 0 11-2 0V5a1 1 0 011-1z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.293 11.293a1 1 0 011.414 0L12 17.586l6.293-6.293a1 1 0 011.414 1.414l-7 7a1 1 0 01-1.414 0l-7-7a1 1 0 010-1.414z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEyIDRDMTIuNTUyMyA0IDEzIDQuNDQ3NzIgMTMgNVYxOUMxMyAxOS41NTIzIDEyLjU1MjMgMjAgMTIgMjBDMTEuNDQ3NyAyMCAxMSAxOS41NTIzIDExIDE5VjVDMTEgNC40NDc3MiAxMS40NDc3IDQgMTIgNFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNC4yOTI4OSAxMS4yOTI5QzQuNjgzNDIgMTAuOTAyNCA1LjMxNjU4IDEwLjkwMjQgNS43MDcxMSAxMS4yOTI5TDEyIDE3LjU4NThMMTguMjkyOSAxMS4yOTI5QzE4LjY4MzQgMTAuOTAyNCAxOS4zMTY2IDEwLjkwMjQgMTkuNzA3MSAxMS4yOTI5QzIwLjA5NzYgMTEuNjgzNCAyMC4wOTc2IDEyLjMxNjYgMTkuNzA3MSAxMi43MDcxTDEyLjcwNzEgMTkuNzA3MUMxMi4zMTY2IDIwLjA5NzYgMTEuNjgzNCAyMC4wOTc2IDExLjI5MjkgMTkuNzA3MUw0LjI5Mjg5IDEyLjcwNzFDMy45MDIzNyAxMi4zMTY2IDMuOTAyMzcgMTEuNjgzNCA0LjI5Mjg5IDExLjI5MjlaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";
export { SvgArrowDown as ReactComponent };